export class Pokretanje {
  korisnik: string;
  nadan: Date;
  dokumentId: number;
  rokdana: number;
  saldaStavkaId: number[]=[];  
}
